export default __webpack_public_path__ + "static/media/logo.39cc4ccc.png";